import { AbacoWebModule, RouterReadyEvent, VueRouter, MenuItem, ApplicationReadyEvent } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import ProcessesVuexModule from './state';
import { createMenu } from './menu';
import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import ProcessApi from './api/ProcessApi';
import MovementApi from './api/MovementApi';
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from '@abaco/sso-web-module/src/abaco-module';
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts/index";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard/index";
import CropPlanModule from "@abaco/crop-plan-module/src/modules/crop-plan-module/index";
import ChartApi from './api/ChartApi';
import PrintApi from './api/PrintApi';
import GlobalStateModule from '@abaco/portal-global-state/src/modules/global-state';

export const MODULE_ID = "processes_module";

const state = new ProcessesVuexModule();
const rootPath = "/sitiInfoRestApi/api_sso/v1"

interface ConstructorOptions {
    environment?: string;
}

export default class ProcessesModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;
    private apiCreated = false;
    private prcApi !: ProcessApi;
    private mvmntApi !: MovementApi;
    private chrtApi!: ChartApi;
    private prtApi!: PrintApi;
    private ssoModule!: SSOModule;

    private router!: VueRouter;

    public readonly environment!: string;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = state;
    menu: MenuItem[] = [];

    constructor(options?: ConstructorOptions) {
        this.environment = options?.environment || "portal"
    }

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule()
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        const tempModule = evt.modules.find(m => m.id === SSO_MODULE_ID) as SSOModule;
        if (!tempModule) {
            throw new Error("SSO Moduel not found");
        }
        this.ssoModule = tempModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;
        const newHttp = new HTTPClient();
        this.ssoModule.addAnauthorizedHandler(newHttp);
        newHttp.addRequestConfigProvider(async config => {
            config.params = config.params || {};
            config.params["workflow"] = "FARMER";
            config.params["SSO_TOKEN"] = await this.ssoModule.getSSOToken();
        })
        const ProcessApi = (await import("./api/ProcessApi")).default;
        this.prcApi = new ProcessApi(newHttp, http, rootPath);
        const MovementApi = (await import("./api/MovementApi")).default;
        this.mvmntApi = new MovementApi(newHttp, rootPath);
        const ChartApi = (await import("./api/ChartApi")).default;
        this.chrtApi = new ChartApi(http, "/sitiagri-rest-api/api_basic/v1");
        const PrintApi = (await import("./api/PrintApi")).default;
        this.prtApi = new PrintApi(http, "/sitiagri-rest-api/api_basic/v1");
    }

    get processApi() {
        return this.prcApi;
    }

    get movementApi() {
        return this.mvmntApi;
    }

    get chartApi() {
        return this.chrtApi;
    }

    get printApi() {
        return this.prtApi;
    }

}
